import { render } from "./update-staff-score.vue?vue&type=template&id=72a81c9a&scoped=true"
import script from "./update-staff-score.vue?vue&type=script&lang=js"
export * from "./update-staff-score.vue?vue&type=script&lang=js"

import "./update-staff-score.vue?vue&type=style&index=0&id=72a81c9a&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a81c9a"]])

export default __exports__